export default __webpack_public_path__ + "static/media/icon-history-active.bcc50d40.svg";